
































































helpers = require('../../helpers.coffee')

view_model = {
  components:
    contactPicker: require '../contacts/picker'
    contactManualPicker: require '../contacts/manual_picker'
    specificTemplatesModal: require '../specific_templates/modal'
    triggers: require './triggers'

  props:
    flow:
      default: -> new Flow

  data: ->
    current_user: Session.current_user
    filters: {}
    fetching_contacts: false
    fetching_specific_templates: false
    current_contact: {}
    selected_contacts: []
    new_contacts: []
    flow_contacts: []
    removed_contacts: []
    contacts: []
    contacts_with_specific_templates: []
    next_page: 1
    contacts_total_count: 0

  computed:
    fetching: ->
      @fetching_contacts || @fetching_specific_templates

    any_filter: ->
      !!Object.keys(@filters).length

    added_contacts: ->
      @selected_contacts.concat(@new_contacts)

    number_of_contacts: ->
      @added_contacts.length + (@contacts_total_count)

    user_id_or_default: ->
      if @flow.user_id then @flow.user_id else Session.current_user.id

  watch:
    flow: (new_flow) ->
      if @flow.isPersisted()
        if(@flow.isWithError())
          @restoreContacts()
        else
          @loadFlowContacts()
          @loadSpecificTemplates()
      else
        EventsBus.$emit 'ContactsPicker:SetPersistedSelectedContacts', contacts: []

    selected_contacts: ->
      @setContacts()

    new_contacts: ->
      @setContacts()

    flow_contacts: ->
      @setContacts()

    contacts: ->
      unless @any_filter
        for contact, index in @contacts
          contact.recipient_priority = index

  methods:
    loadFlowContacts: ->
      return if @fetching_contacts || !@next_page || !@flow.id
      @fetching_contacts = true
      new ContactsResource(Session.current_company.id).lastActiveOnFlow @loadFlowContactsSuccess, @unknownError, flow_id: @flow.id, params: { q: @filters, page: @next_page }

    loadFlowContactsSuccess: (data) ->
      @next_page = data.meta.next_page
      @contacts_total_count = data.meta.total_count unless @any_filter
      @fetching_contacts = false
      @flow_contacts = @flow_contacts.concat(data.contacts)
      @setContacts()

    restoreContacts: ->
      new_contacts = []
      @flow.job_status.contacts.forEach (contact_params) =>
        contact = new Contact(contact_params)
        if contact.id != null
          @selected_contacts.push(contact)
        else
          new_contacts.push(contact)
      EventsBus.$emit 'contacts-picker-text-csv-restore', new_contacts

    loadSpecificTemplates: ->
      @fetching_specific_templates = true
      resource = new ContactSpecificTemplatesResource(Session.current_company.id, @$route.params.id)
      resource.index @loadSpecificTemplatesSuccess, @unknownError, params: { limit: 'disabled' }

    loadSpecificTemplatesSuccess: (resources) ->
      @addPersistedSpecificTemplates(resources)
      @fetching_specific_templates = false

    createSpecificTemplate: (data) ->
      new ContactSpecificTemplate({
        id: data.id,
        flow_action_id: data.flow_action_id,
        contact_id: data.contact_id,
        template_id: data.id,
        subject: data.subject,
        body: data.body,
        signature: data.signature,
        kind: data.kind
      })

    hasSpecificTemplate: (contact) ->
      if contact.id
        @contacts_with_specific_templates.find(contact.id)
      else if contact.email
        @contacts_with_specific_templates.findByProps(email: contact.email)

    updateContactsWithSpecificTemplate: (data, has_template) ->
      index = if data.specific_template.contact_id
        @contacts_with_specific_templates.findIndexByProps(id: data.specific_template.contact_id)
      else
        @contacts_with_specific_templates.findIndexByProps(email: data.specific_template.contact.email)

      if(has_template)
        @contacts_with_specific_templates.push data.specific_template.contact if index < 0
      else
        @contacts_with_specific_templates.splice index, 1 if index > -1

    groupSpecificTemplatesByAction: (data) ->
      self = this
      specific_templates = {}
      data.templates.forEach (template) ->
        action_id = template.flow_action_id
        specific_templates[action_id] = [] if !specific_templates[action_id]
        specific_templates[action_id].push self.createSpecificTemplate(template)
        self.contacts_with_specific_templates.push { id: template.contact_id }

      specific_templates

    addPersistedSpecificTemplates: (data) ->
      self = this
      specific_templates = @groupSpecificTemplatesByAction(data)
      @flow.actions.forEach (action) ->
        action.contact_specific_templates = specific_templates[action.id] unless !specific_templates[action.id]

    openSpecificTemplatesModal: (contact) ->
      @current_contact = contact
      EventsBus.$emit 'confirm-modal-show', id: 'edit-specific-templates'

    removeContact: (contact) ->
      for list in ['new_contacts', 'selected_contacts', 'flow_contacts']
        if @[list].remove(contact.id)
          if list == 'flow_contacts'
            @removed_contacts.push(contact)
          if list != 'new_contacts'
            EventsBus.$emit 'ContactsPicker:AddContact', { contact: contact, selected: false }

    filter: (filters) ->
      @filters = filters
      @next_page = 1
      @flow_contacts = []
      @loadFlowContacts()

    filterContacts: (contacts) ->
      filters = @filters
      contacts.filter (contact) ->
        (!filters.search_query || contact.full_name.toLowerCase().indexOf(filters.search_query.toLowerCase()) > -1) &&
        (!filters.stage_eq || contact.stage == filters.stage_eq) &&
        (!filters.current_recipient_status_eq || contact.recipient_status == filters.current_recipient_status_eq)

    selectContacts: (data) ->
      @selected_contacts = data.contacts.filter (contact) =>
        !contact.flow.hasOwnProperty('id') || contact.flow.id == @flow.id
      @selected_contacts.forEach (contact) ->
        EventsBus.$emit 'ContactsPicker:RemoveContact', contact

    setNewContacts: (data) ->
      @new_contacts = data.contacts

    setContacts: ->
      contacts = [].concat(@flow_contacts) # to copy
      contacts = contacts.concat(@filterContacts(@added_contacts))
      @contacts = contacts.sort (contact_1, contact_2) ->
        return 1 if contact_1.recipient_priority == null
        return -1 if contact_2.recipient_priority == null
        if contact_1.recipient_priority > contact_2.recipient_priority then 1 else -1

    updateContactsPriority: (contacts) ->
      @contacts = contacts

    contactsToSend: ->
      contacts = @contacts.filter((contact) => contact.original_recipient_priority != contact.recipient_priority)
      contacts.concat(@added_contacts.filter (contact) => !contacts.find(contact.id))

    updateTriggers: (data) ->
      @flow.triggers = data

  created: ->
    EventsBus.$on 'contact-picker-contacts-added', @setNewContacts

  beforeDestroy: ->
    EventsBus.$off 'contact-picker-contacts-added', @setNewContacts
}

exports.default = helpers.vue_include(view_model, helpers.contacts.list_view_modes)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/contacts_form.vue